import { inject, Injectable } from '@angular/core';
import { TranslocoLocaleService } from '@jsverse/transloco-locale';

@Injectable({
	providedIn: 'root',
})
export class NumberUtil {
	private translocoLocaleService = inject(TranslocoLocaleService);

	private readonly _deDE = 'de-DE';
	private readonly _enUS = 'en-US';
	public _locale: string;

	constructor() {
		this._locale = this.translocoLocaleService.getLocale() === this._deDE ? this._deDE : this._enUS;
	}

	public roundConsumptionValues(consumptionValue, decimalPlaces: number) {
		if (consumptionValue) {
			const consumptionValueNumber = parseFloat(consumptionValue);
			return consumptionValueNumber.toFixed(decimalPlaces);
		}
		return Number.parseInt('0').toFixed(decimalPlaces);
	}

	scaleAndReplaceDot(value: number, decimalPlaces: number = 0) {
		if (value === undefined) {
			return '';
		} else {
			const scaledValue = this.roundConsumptionValues(value, decimalPlaces);
			return this.replaceDecimalSymbolByLocale(scaledValue);
		}
	}

	replaceDecimalSymbolByLocale(formula: string) {
		if (!formula) {
			return '';
		}
		if (this._locale.includes('de')) {
			return formula.replace('.', ',');
		}
		return formula;
	}

	formatDecimal(value: number | null | undefined, minimumFractionDigits = 2, maximumFractionDigits = 2): string {
		if (value === null || value === undefined || isNaN(value)) {
			return '';
		}
		return new Intl.NumberFormat(this._locale, {
			minimumFractionDigits,
			maximumFractionDigits,
		}).format(value);
	}
}
